export default __webpack_public_path__ + "47d463d34eef0b15ffa0cb60e09b626a.woff2";